import { render, staticRenderFns } from "./QurbanPaymentComplete.vue?vue&type=template&id=6179c52a"
import script from "./QurbanPaymentComplete.vue?vue&type=script&lang=js"
export * from "./QurbanPaymentComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports